import { Box, Chip, CircularProgress, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { getAllData } from "../../libs/firebase/firestore/getAllData";
import { getWeeklyTimeEntries } from "../../libs/toggl/getWeeklyTimeEntires";
import { tagIds } from "../../libs/toggl/tags";
import { SendInvoice } from "./SendInvoice";
import { dataToInvoice } from "../../utilities/dataToInvoice";
import { mailTo } from "../../utilities/mailTo";
import { firebaseDateToDateTime } from "../../utilities/firebaseDateToDateTime";
import ReportButtonPaid from "./Button/Paid";
import { updateTagsOnTimeEntires } from "../../libs/toggl/updateTagsOnTimeEntries";
import ReportButtonResetTags from "./Button/Edit";

export default function ReportInvoiceWeekSummary({
  title,
  mondayDate,
  projects,
  clients,
  tags,
}) {
  // state for timeEntries
  const [timeEntries, setTimeEntries] = React.useState([]);

  // state for resource lists
  const [resourceLists, setResourceLists] = React.useState(null);

  let fridayDate = new Date(mondayDate);
  fridayDate.setDate(fridayDate.getDate() + 4);

  useEffect(() => {
    getWeeklyTimeEntries(mondayDate, (data) => {
      setTimeEntries(data);
    });

    getAllData(
      "resourceLists",
      (data) => {
        // setResourceLists(data);
        // only add the resource list if it is for the current week

        const resourceList = data.filter((resourceList) => {
          let resourceListDate = firebaseDateToDateTime(
            resourceList.timeDateCreated
          );
          return (
            resourceListDate >= mondayDate && resourceListDate <= fridayDate
          );
          //   return resourceList.timeDateCreated === mondayDate;
        });
        setResourceLists(resourceList);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  const updateStatus = () => {
    getWeeklyTimeEntries(mondayDate, (data) => {
      setTimeEntries(data);
    });
  };

  const invoicedTimeEntries = timeEntries.filter((timeEntry) => {
    return timeEntry.tag_ids.includes(tagIds.INVOICE);
  });

  const paidTimeEntries = timeEntries.filter((timeEntry) => {
    return timeEntry.tag_ids.includes(tagIds.PAID);
  });

  const hasInvoiced = invoicedTimeEntries.length > 0;
  const hasPaid = paidTimeEntries.length > 0;

  const invoiceIssue =
    hasInvoiced && timeEntries.length !== invoicedTimeEntries.length;

  const paidIssue = hasPaid && timeEntries.length !== paidTimeEntries.length;

  let billableAmount = timeEntries.reduce((acc, timeEntry) => {
    return acc + timeEntry.billable_amount_in_cents / 100;
  }, 0);

  const handleOnDownloadInvoice = () => {
    window.location.href = mailTo(
      "elisabeth@gardensavvy.ca",
      "Invoice",
      "Hey Elisabeth,\n\n here is the invoice for last week. Hope you are doing well!"
    );
  };

  const handleInvoiced = () => {
    updateStatus();
  };

  const handlePaid = () => {
    updateTagsOnTimeEntires(
      timeEntries,
      ["paid"],
      (data) => {
        updateStatus();
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleReset = () => {
    updateTagsOnTimeEntires(
      timeEntries,
      ["invoice", "paid"],
      (data) => {
        updateStatus();
      },
      (error) => {
        console.log(error);
      },
      "remove"
    );
  };

  // create a subtitle from the mondaydate and friday date a strings DD Month
  const subtitle = `${mondayDate.toLocaleDateString("en-CA", {
    day: "numeric",
  })} - ${fridayDate.toLocaleDateString("en-CA", {
    day: "numeric",
  })} ${fridayDate.toLocaleDateString("en-CA", {
    month: "long",
  })}`;

  return (
    <Box>
      {/* loader */}
      {(!clients || !timeEntries || !projects) && (
        <Box
          style={{
            textAlign: "center",
            margin: "2rem 0rem",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Box>
        <Stack
          direction="row"
          style={{
            margin: "1rem 0rem",
          }}
        >
          <Stack>
            <Typography variant="h6">{title}</Typography>
            {/* subtitle of dates as strings */}
            <Typography variant="subtitle2">{subtitle}</Typography>
          </Stack>
          <div style={{ flexGrow: 1 }}></div>
          <Typography variant="h5">{billableAmount.toFixed(2)}CAD</Typography>
        </Stack>

        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <Chip
              color={hasInvoiced ? "success" : "default"}
              label={hasInvoiced ? "Invoiced" : "Not Invoiced"}
            />
            {hasInvoiced && (
              <Chip
                color={hasPaid ? "success" : "default"}
                label={hasPaid ? "Paid" : "Not Paid"}
              />
            )}
            <div style={{ flexGrow: 1 }}></div>
            {!hasInvoiced && (
              <SendInvoice
                onInvoiced={handleInvoiced}
                timeEntires={timeEntries}
                data={dataToInvoice(
                  timeEntries,
                  clients,
                  projects,
                  tags,
                  resourceLists
                )}
                onClick={handleOnDownloadInvoice}
              />
            )}
            {hasInvoiced && !hasPaid && (
              <ReportButtonPaid onConfirm={handlePaid} />
            )}
            {hasInvoiced && hasPaid && (
              <ReportButtonResetTags onConfirm={handleReset} />
            )}
          </Stack>

          <Stack direction="row" spacing={2}>
            {invoiceIssue && (
              <Chip
                label="Invoice Issue"
                color="error"
                style={{ backgroundColor: "red" }}
              />
            )}
            {paidIssue && (
              <Chip
                label="Paid Issue"
                color="error"
                style={{ backgroundColor: "red" }}
              />
            )}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
